
$(document).ready(function () {  
  initializeSlickSlider('.collection-banner-wrapper');
});

const container = document.querySelector(".collection-banner-container");
const wrapper = document.querySelector(".collection-banner-wrapper");

if (container && wrapper) {
  const updateClass = () => {
    if (wrapper.classList.contains("slick-initialized")) {
      container.classList.remove("collection-carousel-container");
    } else {
      container.classList.add("collection-carousel-container");
    }
  };
  updateClass();

  const observer = new MutationObserver(updateClass);
  observer.observe(wrapper, { attributes: true, attributeFilter: ["class"] });
}


